<script>
import { Line } from 'vue-chartjs'
import { mapGetters, mapState } from 'vuex'

export default {
  extends: Line,
  props: ['charges'],
  mounted () {
    this.renderChart({
      labels: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
      datasets: [
        {
            label: 'Dernier mois',
            backgroundColor: 'rgba(70, 195, 123, .07)',
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, .25)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: [600, 350, 1100, 420, 750, 1050, 670]
        },
        {
            label: 'Dernière semaine',
            backgroundColor: 'rgba(70, 195, 123, .25)',
            borderColor: 'rgba(5, 210, 92, .55)',
            pointBackgroundColor: 'rgba(68, 180, 166, .55)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: [490, 430, 560, 790, 1200, 950, 1500]
        }
      ]
    },{
      scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      scaleFontColor: '#999',
      scaleFontStyle: '600',
      tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      tooltipCornerRadius: 3,
      maintainAspectRatio: false,
      responsive: true
    })
  }
}
</script>



// WEBPACK FOOTER //
// MonthlyFeeChart.vue?6d206610